module.exports = __webpack_public_path__ + "static/gatku-cart-e609c4b71c018c60704fbadbc8d9b44f.gif";